import { LAYOUT_TYPE } from '@sbercloud/uikit-product-utils';
import { useCalculatorContext } from '../contexts';
export function useAdaptive() {
  var _useCalculatorContext = useCalculatorContext(),
    layoutType = _useCalculatorContext.layoutType;
  var isMobile = layoutType === LAYOUT_TYPE.Mobile;
  var isTablet = layoutType === LAYOUT_TYPE.Tablet;
  var isDesktopSmall = layoutType === LAYOUT_TYPE.DesktopSmall;
  var isDesktop = layoutType === LAYOUT_TYPE.Desktop;
  return {
    layoutType: layoutType,
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktopSmall: isDesktopSmall,
    isDesktop: isDesktop
  };
}